import React, { useState, useEffect } from "react";
import SelfRegistrationForm from "../../components/Forms/SelfRegistrationForm";
import axios from "../../services/api/api";
import { useLocation } from "react-router-dom";

function StudentSelfRegistration() {
  const location = useLocation();
  const [email, setEmail] = useState(null);
  const [role, setRole] = useState(null);
  const [validationtoken, setValidationtoken] = useState(null);

  useEffect(() => {
    if (location.search) {
      const checkSum = location.search.split("?check=")[1];
      axios
        .get("/User/Validation?email=" + encodeURIComponent(checkSum))
        .then((response) => {
          setEmail(response.data.result.email);
          setRole(response.data.result.role);
          setValidationtoken(
            response.data.result.validationToken
              ? response.data.result.validationToken
              : null
          );
        })
        .catch(() => {
          setEmail(null);
          setRole(null);
        });
    }
  }, [location.search]);

  return (
    <SelfRegistrationForm
      validationtoken={validationtoken}
      email={email}
      role={role}
    />
  );
}

export default StudentSelfRegistration;
